import { GET_EVENT_TYPES } from "constants/eventTypes";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_EVENT_TYPES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
